import {omit} from 'external/lodash'
import {
   forwardRef
  ,NavLink
  ,useLocation
  ,stringifyQueryString
} from 'external/react'

const SortLink = forwardRef(
  (props, ref) => {
    const location = useLocation()
    const orderBy = `${props.orderBy == props.property && props.order == 'asc' ? '-' : ''}${props.property}`
    return <NavLink
      ref={ref}
      to={`${location.pathname}?${stringifyQueryString({orderBy})}`}
      {...omit(props, ['order', 'property', 'orderBy'])}
    />
  }
)

export {SortLink as default}
